import { combineReducers } from 'redux';
import { cart } from './Reducers/Cart.reducer';
import { checkout } from './Reducers/Checkout.reducer';
import { newsletterSignUpModal } from './Reducers/NewsletterSignUpModal.reducer';
import { flashMessages } from './Reducers/FlashMessages.reducer';
import { softwareLicenseDirectDepositModal } from './Reducers/SoftwareLicenseDirectDepositModal.reducer';
import { userDemoedLicenseProducts } from './Reducers/UserDemoedLicenseProducts.reducer';
import { userOwnedFullLicenseProducts } from './Reducers/UserOwnedFullLicenseProducts.reducer';
import { flowCreditPurchaseModal } from './Reducers/FlowCreditPurchaseModal.reducer';
import { flowCreditUpgradePurchaseModal } from './Reducers/FlowCreditUpgradePurchaseModal.reducer';
import { myAccountChangeEmail, myAccountUserInfo, myAccountChangePassword } from './Reducers/MyAccount.reducer'
import { generalErrors } from './Reducers/Error.reducer';
import { registerLicenseCode } from './Reducers/RegisterLicenseCode.reducer';
import { linkIlok } from './Reducers/LinkIlok.reducer';
import { myAccountMySubscriptions } from './Reducers/MyAccountMySubscriptions.reducer';

const staticReducers = {
    cart,
    checkout,
    newsletterSignUpModal,
    flashMessages,
    softwareLicenseDirectDepositModal,
    userDemoedLicenseProducts,
    userOwnedFullLicenseProducts,
    flowCreditPurchaseModal,
    flowCreditUpgradePurchaseModal,
    myAccountUserInfo,
    myAccountChangeEmail,
    myAccountChangePassword,
    generalErrors,
    registerLicenseCode,
    linkIlok,
    myAccountMySubscriptions
};

const app = combineReducers(staticReducers);

export const createReducer = (asyncReducers) => {
    return combineReducers({
        ...staticReducers,
        ...asyncReducers,
    });
};

export default app;
